import { type ReactElement } from 'react';
import { type VehicleCycledEnergyRecord } from '../../services/battery-monitoring-api/types/battery-monitoring-api';
import Chart from '../utils/Chart';
import { type UpdateQueryParameterValues } from '../../hooks/use-update-query-parameter-values';
import useChartItems from './hooks/use-chart-items';
import { type SelectedChartSegment, stateOfHealthConfig } from '@/app/config/chart-segments';

interface StateOfHealthProperties {
  readonly chartVehicles: VehicleCycledEnergyRecord[];
  readonly selectedStateOfHealthSegment: SelectedChartSegment | null;
  readonly updateQueryParameterValues: UpdateQueryParameterValues;
}

const StateOfHealthChart = ({
  chartVehicles,
  selectedStateOfHealthSegment,
  updateQueryParameterValues,
}: StateOfHealthProperties): ReactElement => {
  const items = useChartItems(chartVehicles);

  return (
    <Chart
      header="State of Health (Estimation)"
      items={items}
      iconName="24v_battery"
      selectedSegment={selectedStateOfHealthSegment}
      indexKey={stateOfHealthConfig.indexKey}
      updateQueryParameterValues={updateQueryParameterValues}
    />
  );
};

export default StateOfHealthChart;
